import React from 'react';
import { ModalBackdrop, ModalContainer } from 'is24-corecss';
import { css } from '@emotion/css';
import { GRAY100 } from '@/domain/colors';
import { Banner } from '@/components/content/successModal/banner/Banner';
import { useModalFocus } from '@/customHooks/useModalFocus.hook';
import { useBodyScroll } from '@/customHooks/useBodyScroll.hook';

const styles = {
  container: {
    maxWidth: 760,
    width: '100% !important',
    maxHeight: '100vh',
    overflowX: 'hidden',
    '@media (max-width: 668px)': {
      position: 'fixed',
      overflowY: 'scroll',
      top: 0,
    },
  },
  containerBanner: {
    background: 'rgb(51,51,51)!important',
  },
  closeBtn: {
    color: `${GRAY100} !important`,
    '&:hover': {
      backgroundColor: 'transparent !important',
    },
  },
  modalContent: {
    display: 'flex',
    overflowX: 'hidden',
    maxHeight: '100vh !important',
    marginTop: '-5px',
    '@media (max-width: 668px)': {
      height: '100vh !important',
    },
  },
  modalBackDrop: css`
    z-index: 2500;
    /* iOS webview stacking context fixes */
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    will-change: transform;
  `,
} as const;

interface SuccessModalProps {
  onClose: () => void;
  variant: 'mieten' | 'wohnen';
}

export const SuccessModal: React.FC<SuccessModalProps> = ({ onClose, variant }) => {
  useModalFocus(true);
  useBodyScroll(true);
  return (
    <ModalBackdrop visible={true} onClose={onClose} className={css(styles.modalBackDrop)}>
      <ModalContainer
        closeBtnClassName={`${css(styles.closeBtn)}`}
        containerClassName={`Modal ${css(styles.container)} ${css(styles.containerBanner)}`}
        contentWrapperClassName={`absolute-reference ${css(styles.modalContent)}`}
        visible={true}
        modalTitle={' '}
        onClose={onClose}
      >
        <Banner onClose={onClose} variant={variant} />
      </ModalContainer>
    </ModalBackdrop>
  );
};
